<template>
  <div class="order-detail" id="orderDetail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toOrderList">订货单/</span>
        {{pageModule ? '订单编辑' : '订单详情'}}
      </template>
      <template v-slot:content>
        <div class="radios-container">
          <el-radio-group v-model="infoType">
            <el-radio-button :label="infoTypes.orderInfo">订单信息</el-radio-button>
            <el-radio-button :label="infoTypes.shipmentInfo">出货/发货信息</el-radio-button>
            <el-radio-button :label="infoTypes.paymentRecords">付款记录</el-radio-button>
            <el-radio-button v-if="repairList.length>0" :label="infoTypes.repairInfo">返修信息</el-radio-button>
            <el-radio-button :label="infoTypes.operationLog">操作日志</el-radio-button>
          </el-radio-group>
          <el-button v-if="currOrderStatus > 3 && currOrderStatus < 9" class="btn-white invalidate" @click="invalidate">作废</el-button>
        </div>
        <!-- 订单信息 -->
        <div class="base-content" ref="baseContent"></div>
        <div class="order-information" v-show="isShowOrderInfo">
          <div class="customer-related">
            <div class="top">
              <div class="left">
                <div class="left-row">
                  <div class="container">
                    <span class="desc">客户名称：</span>
                    <span class="content">{{customInfo.name}}</span>
                  </div>
                  <div class="container">
                    <span class="desc">所在地区：</span>
                    <span class="content" v-if="customInfo.area">{{customInfo.area}}</span>
                    <span class="content" v-else>无</span>
                  </div>
                </div>
                <div class="left-row">
                  <div class="container">
                    <span class="desc">联系人：</span>
                    <span class="content">{{customInfo.contact}}</span>
                  </div>
                  <div class="container">
                    <span class="desc">联系方式：</span>
                    <span class="content">{{customInfo.telephone}}</span>
                  </div>
                </div>
                <!-- <div class="left-row">
                  <div class="container">
                    <span class="desc">支付状态：</span>
                    <span
                      class="content"
                    >{{customInfo.payStatus===1 ? '已支付' :customInfo.payStatus===0 ? '未支付':'已关闭'}}</span>
                  </div>
                  <div class="container">
                    <span class="desc">支付方式：</span>
                    <span class="content">{{customInfo.payMethodDesc }}</span>
                  </div>
                </div> -->
              </div>
              <div class="right">
                当前订单状态:
                <span class="order-status">{{currOrderDesc}}</span>
              </div>
            </div>
            <div class="bottom">
              <span class="desc">买家留言：</span>
              <span class="content">{{customInfo.message}}</span>
            </div>
          </div>
          <div class="order-detail-related">
            <div class="table-img">
              <el-table class="table-container" :data="orderDetail">
                <el-table-column label="商品名称" width="400">
                  <template slot-scope="props">
                    <img class="img" width="20" height="20" :src="props.row.commodityImg" alt />
                    <span class="setMeal-tags" v-if="props.row.setMealId">套餐</span>
                    <p class="name" :title="props.row.commodityName">{{props.row.commodityName}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="规格" prop="norm"></el-table-column>
                <el-table-column label="数量" prop="amount" class="amount-column">
                  <template slot-scope="props">
                    <span class="column-amount" v-show="isViewModule||isMeal">{{props.row.amount}}</span>
                    <int-input
                      class="amount-input"
                      v-show="isEditModule && !isMeal"
                      :updateIndex="props.$index"
                      :intNum="Number(props.row.amount)"
                      @update="onUpdateAmount"
                      @complete="filterAmountNum"
                    ></int-input>
                  </template>
                </el-table-column>
                <el-table-column label="单价" prop="unitPrice">
                  <template slot-scope="props">
                    <span
                      class="column-amount"
                      v-show="isViewModule||isMeal"
                    >{{props.row.unitPriceShow}}</span>
                    <decimal-input
                      v-show="isEditModule && !isMeal"
                      class="amount-input"
                      :updateIndex="props.$index"
                      :decimalNum="props.row.unitPrice"
                      @update="onUpdateUnitPrice"
                      @complete="filterUnitPrice"
                    ></decimal-input>
                  </template>
                </el-table-column>
                <el-table-column label="小计" prop="subtotal">
                  <template slot-scope="props">
                    <p v-show="isViewModule">
                      <span
                        :class="props.row.promotionReduce>0?'column-subtotal scribing':'column-subtotal'"
                      >{{props.row.subtotal}}</span>
                      <span
                        class="column-subtotal"
                        v-if="props.row.promotionReduce>0"
                      >{{props.row.subtotal-props.row.promotionReduce}}</span>
                    </p>
                    <el-input
                      v-show="isEditModule"
                      class="gray"
                      v-model.number="props.row.subtotal"
                      :disabled="true"
                    ></el-input>
                    <span
                      class="delete-btn"
                      v-show="isEditModule && props.row.isTemp"
                      @click="delTableTemporary(props.$index,props.row.id)"
                    >删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="temporary-container">
              <div class="temporary-item" v-for="(value,index) in temporaryData" :key="index">
                <div class="temporary-name">
                  <el-input class="gray" v-model="value.goodsName"></el-input>
                </div>
                <div class="temporary-spec">
                  <el-input class="gray" v-model="value.itemTitle"></el-input>
                </div>
                <div class="temporary-num">
                  <int-input
                    class="good-amount"
                    :updateIndex="index"
                    :intNum="Number(value.quantity)"
                    @update="onUpdateTemporary"
                    @complete="filterTemporary"
                  ></int-input>
                </div>
                <div class="temporary-price">
                  <decimal-input
                    class="discount-input"
                    :decimalNum="value.unitPrice"
                    @complete="filterTemporaryUnitPrice($event,index)"
                  ></decimal-input>
                </div>
                <div class="temporary-total">
                  <el-input
                    class="gray"
                    disabled
                    :value="Number(value.unitPrice)*Number(value.quantity)"
                  ></el-input>
                  <span class="delete-btn" @click="delTemporary(index)">删除</span>
                </div>
              </div>
            </div>
            <div class="subtotal" v-show="isViewModule">
              <div class="detail">
                <div class="order-total">
                  <span class="desc" v-if="isMeal">套餐合计</span>
                  <span class="desc" v-else>商品合计</span>
                  ：{{(paymentInfo.orderTotal +temporaryTotal).toFixed(2)}}
                </div>
                <div class="order-freight">
                  <span class="desc">+运费</span>
                  ：{{paymentInfo.freight}}
                </div>
                <div class="order-discount">
                  <span class="desc">-商家优惠</span>
                  ：{{paymentInfo.discount}}
                </div>
                <div class="order-couponPrice">
                  <span class="desc">-优惠劵</span>
                  ：{{paymentInfo.couponPrice}}
                </div>
                <div class="order-promotionPrice">
                  <span class="desc">-促销</span>
                  ：{{paymentInfo.promotionPrice}}
                </div>
                <div class="order-promotionPrice">
                  <span class="desc">-套餐</span>
                  ：{{paymentInfo.setMeal}}
                </div>
                <div class="order-promotionPrice" v-if="modulePoints">
                  <span class="desc">-积分</span>
                  ：{{paymentInfo.integralValue}}
                </div>
              </div>
              <span class="amounts-payable">
                应付金额：
                <span class="need-to-pay-amount">￥{{paymentInfo.needToPay}}</span>
              </span>
            </div>
            <div class="subtotal-edit" v-show="isEditModule">
              <div class="detail">
                <div class="order-total">
                  <span class="desc" v-if="isMeal">套餐合计：</span>
                  <span class="desc" v-else>商品合计：</span>
                  <!-- <el-input v-if="isMeal" class="gray" v-model.number="paymentInfo.orderTotal"></el-input>
                  <el-input
                    v-else
                    class="gray"
                    v-model.number="paymentInfo.orderTotal"
                    :disabled="true"
                  ></el-input>-->
                  <decimal-input
                    v-if="isMeal"
                    class="orderTotal-input"
                    :decimalNum="paymentInfo.orderTotal"
                    @complete="filterOrderTotal"
                  ></decimal-input>
                  <el-input
                    v-else
                    class="gray orderTotal-input"
                    :value="paymentInfo.orderTotal+temporaryTotal"
                    :disabled="true"
                  ></el-input>
                </div>
                <div class="order-freight">
                  <span class="desc">+运费：</span>
                  <decimal-input
                    class="freight-input"
                    :decimalNum="paymentInfo.freight"
                    @complete="filterFreightNum"
                  ></decimal-input>
                </div>
                <div class="order-discount">
                  <span class="desc">-商家优惠：</span>
                  <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.discount"
                    @complete="filterDiscountNum"
                  ></decimal-input>
                </div>
                <div class="order-discount">
                  <span class="desc">-优惠劵：</span>
                  {{paymentInfo.couponPrice}}
                  <!-- <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.couponPrice"
                    @complete="filterCouponPriceNum"
                  ></decimal-input> -->
                </div>
                <div class="order-discount">
                  <span class="desc">-促销：</span>
                  {{paymentInfo.promotionPrice}}
                  <!-- <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.promotionPrice"
                    @complete="filterPromotionPriceNum"
                  ></decimal-input> -->
                </div>
                <div class="order-discount">
                  <span class="desc">-套餐：</span>
                  {{paymentInfo.setMeal}}
                </div>
                <div class="order-discount">
                  <span class="desc">-积分：</span>
                  {{paymentInfo.integralValue}}
                </div>
              </div>
              <div class="amounts-payable">
                <span class="desc">应付金额：￥</span>
                <el-input class="gray" v-model="paymentInfo.needToPay" :disabled="true"></el-input>
              </div>
            </div>
            <div class="add-commodity-btn" v-show="isEditModule && moduleTempGoods">
              <span class="add-btn" @click="addTemporary">添加临时商品</span>
            </div>
          </div>
          <div class="pay-detail-related">
            <div class="container">
              <span class="desc">订单号：</span>
              <span class="content">{{orderInfo.orderNum}}</span>
            </div>
            <div class="container" v-show="!!orderInfo.paymentNum">
              <span class="desc">支付流水号：</span>
              <span class="content">{{orderInfo.paymentNum}}</span>
            </div>
            <div class="container">
              <span class="desc">下单时间：</span>
              <span class="content">{{orderInfo.createOrderTime}}</span>
            </div>
            <!-- <div class="container" v-show="!!orderInfo.completePayTime">
              <span class="desc">付款时间：</span>
              <span class="content">{{orderInfo.completePayTime}}</span>
            </div> -->
            <div class="container" v-show="!!orderInfo.completeOrderTime">
              <span class="desc">完成时间：</span>
              <span class="content">{{orderInfo.completeOrderTime}}</span>
            </div>
            <!-- 线下凭证 -->
            <!-- <div
              class="offline-payment-info"
              v-show="customInfo.payStatus && customInfo.payMethod === 1"
            >
              <div class="view-voucher container">
                <span class="btn-desc">交易凭证：</span>
                <span v-if="voucherList.length > 0" class="btn" @click="viewVoucher">查看大图</span>
              </div>
              <div class="view-remark container">
                <span class="btn-desc">备注：</span>
                <div class="remark">{{paymentInfo.message}}</div>
              </div>
            </div> -->
            <div class="container container-remark">
              <span class="desc">商家备注：</span>
              <p class="content" v-show="isViewModule">
                <span v-if="orderInfo.dbMessage">{{orderInfo.dbMessage}}</span>
                <span v-else>暂无</span>
              </p>
              <p class="textarea">
                <el-input
                  type="textarea"
                  v-model="orderInfo.dbMessage"
                  :rows="3"
                  placeholder="请输入商家备注"
                  v-show="isEditModule"
                ></el-input>
              </p>
            </div>
          </div>
        </div>
        <!-- 出货发货信息 -->
        <div class="shipment-info" v-show="isShowShipmentInfo">
          <!-- 出货发货信息--预览模式 -->
          <div class="shipment-info-preview" v-show="isViewModule">
            <!-- 订单详情 -->
            <div class="order-info">
              <div class="code-status">
                <div class="code">
                  <span class="desc">订单号：</span>
                  {{orderCode}}
                </div>
                <span class="status">状态：{{currOrderDesc}}</span>
              </div>
              <div class="receiver">
                <span class="desc">收件信息：</span>
                {{receiptInfo.receiver}}，{{receiptInfo.telephone}}，{{receiptInfo.fullAddress}}
                <i v-if="0 < currOrderStatus && currOrderStatus< 10" class="el-icon-edit" @click="modHarvestAddress"></i>
              </div>
            </div>
            <!-- 待发货商品清单列表 -->
            <div class="good-list">
              <div class="top">
                <div class="title">待发货商品清单</div>
                <el-button class="btn-blue" v-if="isShowShipBtn" @click="onShip">发货</el-button>
                <el-button class="btn-blue" v-if="isShowOutOfStoreBtn" @click="reviewOutOfStore">出库</el-button>
              </div>
              <div class="table-img">
                <el-table class="table-container" :data="orderDetail">
                  <el-table-column label="商品名称" width="400">
                    <template slot-scope="props">
                      <img class="img" width="20" height="20" :src="props.row.commodityImg" alt="人" />
                      <span class="setMeal-tags" v-if="props.row.setMealId">套餐</span>
                      <a
                        class="name"
                        :title="props.row.commodityName"
                      >{{props.row.commodityName}}</a>
                        <!-- :href="`http://${domain}/product?id=${props.row.id}`"
                        target="view_window" -->
                    </template>
                  </el-table-column>
                  <el-table-column label="出货仓库" v-if="moduleStorage ===1">
                    <template slot-scope="props">
                      <p>{{props.row.wareHouseName}}</p>
                      <!-- <el-select
                        v-if="!props.row.isTemp"
                        class="gray"
                        v-model="props.row.selectedStoreId"
                      >
                        <el-option
                          v-for="(store, index) in props.row.storeList"
                          :key="index"
                          :label="store.desc"
                          :value="store.id"
                        ></el-option>
                      </el-select> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="已订购" prop="numOfOrder"></el-table-column>
                  <el-table-column
                    label="已出库"
                    prop="numOfOut"
                    v-if="moduleStorage ===1"
                  ></el-table-column>
                  <el-table-column label="本次出库" width="180">
                    <template slot-scope="props">
                      <el-input
                        v-if="!props.row.isTemp"
                        v-model="props.row.currNumOfOut"
                        class="gray"
                        disabled
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 操作记录 -->
            <div class="operation-record">
              <div class="title">出库/发货记录</div>
              <div class="record-detail" v-if="outStoreRecordIsEmpty">
                <!-- 订单操作记录 -->
                <div class="record-info">
                  <div class="row" v-for="(record, index) in outStoreRecordList" :key="index">
                    <div class="desc">【出库信息】</div>
                    <div class="item">出库单号：{{record.outStoreCode}}</div>
                    <div class="item">出库时间：{{record.outStoreTime}}</div>
                    <div class="item">出库仓库：{{record.outStoreName}}</div>
                  </div>
                </div>
                <!-- 物流快递信息 -->
                <div class="express-info" v-if="isShowExpress">
                  <div class="desc">【发货信息】</div>
                  <div class="item">运单编号：{{expressInfo.waybillCode}}</div>
                  <div class="item">物流公司：{{expressInfo.express}}</div>
                  <div class="item view-btn">
                    物流详情：
                    <el-button type="text" @click="dialogVisible = true">查看物流</el-button>
                    <el-dialog
                      class="express-dialog"
                      title="物流信息"
                      :visible.sync="dialogVisible"
                      width="400px"
                      top="25vh"
                    >
                      <p class="border"></p>
                      <div class="container" v-if="expressInfo.express !== '无'">
                        <div class="express">
                          <p class="express-p">{{expressInfo.express}}</p>
                          <p class="express-p">单号：{{expressInfo.waybillCode}}</p>
                        </div>
                        <ul class="list">
                          <li v-for="(value,index) in LogisDetail " :key="index">
                            <i></i>
                            <p class="space">{{value.remark}}</p>
                            <p class="time">{{value.datetime}}</p>
                          </li>
                        </ul>
                      </div>
                      <div class="nothing" v-else>暂无物流信息</div>
                    </el-dialog>
                  </div>
                </div>
              </div>
              <div class="record-empty-tip" v-else>暂无数据</div>
            </div>
          </div>
          <!-- 出货发货信息--编辑模式 -->
          <div class="logistic-edit" v-show="isEditModule">
            <span class="title">收货信息</span>
            <div class="container">
              <span class="desc">收货人：</span>
              <el-input class="gray" v-model="receiptInfo.receiver"></el-input>
            </div>
            <div class="container">
              <span class="desc">联系方式：</span>
              <el-input class="gray" v-model="receiptInfo.telephone"></el-input>
            </div>
            <div class="container">
              <span class="desc">收货地址：</span>
              <el-cascader
                v-model="receiptInfo.proCityDisIdArr"
                :options="addressList"
                :props="cascaderProps"
              ></el-cascader>
            </div>
            <div class="container">
              <span class="desc">详细地址：</span>
              <el-input class="gray special" v-model="receiptInfo.address"></el-input>
            </div>
          </div>
        </div>
        <div class="operations" ref="operations">
          <div class="btns" v-show="isViewModule">
            <el-button class="btn-white printer" v-show="!isShowPaymentRecords&&!isShowOperationLog" icon="el-icon-printer" @click="openPrinterDialog"></el-button>
            <el-button class="btn-white" @click="toOrderList">返回</el-button>
            <el-button class="btn-blue" v-show="isShowPaymentRecords&&customInfo.payStatus == 0?paymentAddFlag:false" @click="paymentSave">保存</el-button>
            <el-button v-if="(currOrderStatus == 1 || currOrderStatus == 4)&&!isShowPaymentRecords&&!isShowOperationLog" class="btn-white" @click="onCheck">审核</el-button>
            <el-button class="btn-white" v-show="!isShowPaymentRecords&&!isShowOperationLog" @click="encore">再来一单</el-button>
            <el-button
              v-show="isShowViewFooterOperation&&!isShowPaymentRecords&&!isShowOperationLog"
              class="btn-blue"
              @click="toUpdateOrder"
            >修改订单</el-button>
          </div>
          <div class="btns-edit" v-if="isEditModule&&!isShowPaymentRecords">
            <el-button class="btn-white" @click="cancelUpdate">取消</el-button>
            <el-button class="btn-blue" @click="updateOrder">保存</el-button>
          </div>
        </div>
        <!-- 返修信息 -->
        <div class="repair-info" v-show="isShowRepairInfo">
          <div class="table-img">
            <el-table class="table-container" :data="repairList" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="32"></el-table-column>
              <el-table-column label="创建时间" prop="createTime"></el-table-column>
              <el-table-column label="商品名称" prop="goodsName"></el-table-column>
              <el-table-column label="商品数量" prop="quantity"></el-table-column>
              <el-table-column label="备注" prop="message"></el-table-column>
            </el-table>
          </div>  
        </div>
        <!-- 付款记录 -->
        <div class="payment-records order-information" v-show="isShowPaymentRecords">
          <div class="payment-head customer-related">
            <div class="top">
              <div class="left">
                <div class="left-row">
                  <div class="container">
                    <span class="desc">订单号：</span>
                    <span class="content">{{orderInfo.orderNum}}</span>
                  </div>
                  <div class="container">
                    <span class="desc">订单金额：</span>
                    <span class="content">￥{{paymentPrice}}</span>
                  </div>
                </div>
                <div class="left-row">
                  <div class="container">
                    <span class="desc">尚未支付：</span>
                    <span class="content">￥{{outstanding}}</span>
                  </div>
                </div>
              </div>
              <div class="right">
                <el-button v-show="customInfo.payStatus == 0?paymentAddFlag:false" :disabled="paymentAccount" :class="paymentAccount?'btn-black':'btn-blue'" @click="addPaymentRecords">添加付款记录</el-button>
              </div>
            </div>
          </div>
          <div class="table-img">
            <el-table class="table-container" :data="paymentRecordsList" ref="table">
              <el-table-column label="支付流水号" prop="tradeSerialNo"></el-table-column>
              <el-table-column label="付款时间" prop="payDate"></el-table-column>
              <el-table-column label="付款金额" prop="payAmount"></el-table-column>
              <el-table-column label="支付方式" prop="payTypeValue"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.paymentDetailsFlag"
                    class="btn-text"
                    type="text"
                    @click="toogleExpand(scope.row)"
                  >查看详情</el-button>
                  <el-button
                    v-else
                    class="btn-text"
                    type="text"
                    @click="putExpand(scope.row)"
                  >收起详情</el-button>
                </template>
              </el-table-column>
              <el-table-column type="expand" width="1">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="支付流水号">
                        <span>{{ props.row.tradeSerialNo }}</span>
                      </el-form-item>
                      <el-form-item label="付款时间">
                        <span>{{ props.row.payDate }}</span>
                      </el-form-item>
                      <el-form-item label="付款金额">
                        <span>{{ props.row.payAmount }}</span>
                      </el-form-item>
                      <el-form-item label="支付方式">
                        <span>{{ props.row.payTypeValue }}</span>
                      </el-form-item>
                      <el-form-item label="支付信息">
                        <span>{{ props.row.accountInfo }}</span>
                      </el-form-item>
                      <el-form-item :label="'备'+'\xa0\xa0\xa0\xa0\xa0\xa0'+'注'">
                        <span>{{ props.row.desc }}</span>
                      </el-form-item>
                      <el-form-item :label="'附'+'\xa0\xa0\xa0\xa0\xa0\xa0'+'件'">
                        <span class="table-enclosure">
                          <el-image 
                            v-if="props.row.certificate.length > 0?true:false"
                            style="width: 100px; height: 100px"
                            :src="props.row.certificate[0]" 
                            :preview-src-list="props.row.certificate">
                          </el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </span>
                      </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="payment-foot" v-if="paymentAccount">
            <div class="payment-foot-title">选择打款账号</div>
            <div class="payment-foot-top">
              <div class="payment-foot-top-main" v-for="(item,index) in paymentList" :key="index">
                <el-radio v-model="paymentRadio" :label="item.id" @change="changeRadio(item)">{{item.accountName}}</el-radio>
                <div>{{item.bankName}}</div>
                <div>{{item.accountCode}}</div>
              </div>
            </div>
            <div class="payment-foot-bottom">
              <div>
                <span>汇款金额：</span>
                <el-input class="gray" v-model="payAmount" disabled clearable></el-input>
              </div>
              <div class="required">
                <span>
                  <img src="../../../../assets/commodity/required.png">
                  汇款流水号：</span>
                <el-input class="gray" v-model="tradeSerialNo" clearable></el-input>
              </div>
              <div class="required">
                <span>
                  <img src="../../../../assets/commodity/required.png">
                  付款时间：</span>
                <el-date-picker
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择时间"
                  v-model="payDate"
                  style="width: 100%;"
                  clearable>
                </el-date-picker>
              </div>
              <div class="textarea">
                <span>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span>
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="desc" class="gray"></el-input>
              </div>
              <div class="enclosure">
                <span>附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件：</span>
                <el-upload
                  class="upload-voucher"
                  action="#"
                  accept="image/jpeg, image/png, image/jpg"
                  :show-file-list="false"
                  :on-change="imgFileChange"
                  :before-upload="beforeUploadImg"
                  :http-request="uploadImg"
                  :multiple="false"
                >
                  <el-button class="btn" type="primary"
                    >点击上传</el-button
                  >
                  <div slot="tip" class="tip">
                    请上传付款相关的图片,且不超过2M
                  </div>
                </el-upload>
              </div>
              <div
                class="preview-container"
                v-show="voucherImgList.length"
              >
                <div
                  class="img-container"
                  v-for="(imgSrc, index) in voucherImgList"
                  :key="index"
                >
                  <img class="uploaded-img" :src="imgSrc" />
                  <div class="cover">
                    <i
                      class="delete-btn"
                      @click="removeVoucherImg(index)"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
        <!-- 操作日志 -->
        <div class="order-information operation-log" v-show="isShowOperationLog">
          <div class="table-img">
            <el-table class="table-container" :data="operationLogList">
              <el-table-column label="操作人" prop="operator"></el-table-column>
              <el-table-column label="时间" prop="operatorTime"></el-table-column>
              <el-table-column label="类型" prop="operatorType"></el-table-column>
              <el-table-column label="日志内容">
                <template slot-scope="scope">
                  <div v-if="scope.row.operatorType === '发货确认'" class="operator-btn">
                    <p>订单已被发货，</p>
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="toShipmentInfo"
                    >出货/发货信息</el-button>
                  </div>
                  <div v-else-if="scope.row.operatorType === '订单付款'" class="operator-btn">
                    <p>订单完成支付，</p>
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="toPaymentRecords"
                    >付款记录</el-button>
                  </div>
                  <div v-else>{{ scope.row.content }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 发货弹框 -->
        <el-dialog class="to-ship-container" :visible.sync="showShipDialog" width="420px">
          <span class="title" slot="title">确认发货</span>
          <div class="content">
            <div class="container">
              <span class="label">物流公司:</span>
              <el-select class="gray" v-model="selectedLogis" filterable placeholder="请选择物流公司">
                <el-option
                  v-for="item in logisList"
                  :key="item.id"
                  :label="item.expressName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="container">
              <span class="label">运单号:</span>
              <el-input class="gray" v-model="waybillCode" placeholder="请输入运单号"></el-input>
            </div>
          </div>
          <div slot="footer" class="btns">
            <el-button class="btn-white" @click="cancelShip">取消</el-button>
            <el-button class="btn-blue" @click="toShip">保存</el-button>
          </div>
        </el-dialog>
        <!-- 凭证轮播图 -->
        <div class="cover" v-show="showVoucher">
          <div class="close-btn-container">
            <div class="close-btn" @click="closeVoucher">X</div>
          </div>
          <div class="carousel-container">
            <div class="viewport">
              <ul class="carousel-list" ref="carouselList">
                <li class="carousel-item" v-for="(item, index) in voucherList" :key="index">
                  <img class="voucher-img" :src="item" alt="凭证" />
                </li>
              </ul>
            </div>
            <div class="prev-btn" @click="prevVoucher"></div>
            <div class="next-btn" @click="nextVoucher"></div>
          </div>
          <div class="tip">{{tip}}</div>
        </div>
        <!-- 打印 -->
        <el-dialog class="printer-dialog" top="10vh" :visible.sync="printerDialog" width="760px">
          <div class="printer" id="printer">
            <div v-show="!isShowRepairInfo">
              <p class="printer-title">订货单</p>
              <div class="printer-message">
                <ul class="list">
                  <li class="list-item">
                    <span>订货单号：</span>
                    <span v-show="isMeal">(套餐)</span>
                    <span>{{orderInfo.orderNum}}</span>
                  </li>
                  <li class="list-item">客户姓名：{{customInfo.name}}</li>
                  <li class="list-item">收货地址：{{receiptInfo.fullAddress}}</li>
                </ul>
                <ul class="list list-right">
                  <li class="list-item">下单时间：{{orderInfo.createOrderTime}}</li>
                  <li class="list-item">收货人：{{receiptInfo.receiver}}</li>
                  <li class="list-item">联系方式：{{receiptInfo.telephone}}</li>
                </ul>
              </div>
              <div class="table">
                <el-table class="table-printer" :data="orderDetail" style="width:100%">
                  <el-table-column label="序号" width="50">
                    <template slot-scope="props">
                      <span>{{props.$index+1}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品名称">
                    <template slot-scope="props">
                      <p>{{props.row.commodityName}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品编码" prop="code" width="140"></el-table-column>
                  <el-table-column label="规格" prop="norm" width="90"></el-table-column>
                  <el-table-column label="数量" prop="amount" width="58"></el-table-column>
                  <el-table-column label="单价" prop="unitPriceShow" width="90"></el-table-column>
                  <el-table-column label="小计" prop="subtotal" width="143">
                    <template slot-scope="props">
                      <span
                        :class="props.row.promotionReduce>0?'scribing':''"
                      >{{props.row.subtotal}}</span>
                      <span 
                        v-if="props.row.promotionReduce>0">{{props.row.subtotal-props.row.promotionReduce}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="price">
                  <div class="price-left">
                    <p>订单合计：{{paymentInfo.orderTotal}}</p>
                    <p>运费：{{paymentInfo.freight}}</p>
                    <p>-优惠金额：{{paymentInfo.discount+paymentInfo.couponPrice+paymentInfo.promotionPrice}}</p>
                  </div>
                  <div class="price-right">
                    <p>应付金额：{{paymentInfo.needToPay}}</p>
                  </div>
                </div>
                <div class="remark">
                  <p class="remark-title">买家留言</p>
                  <p class="remark-content">{{customInfo.message}}</p>
                </div>
                <div class="remark">
                  <p class="remark-title">商家备注</p>
                  <p class="remark-content">{{orderInfo.dbMessage}}</p>
                </div>
              </div>
              <div class="printer-option-message">
                <p>打印时间：{{nowDate}}</p>
                <p>操作员：{{userRealName}}</p>
              </div>
              <div class="printer-logistics" v-if="expressInfo.waybillCode">
                <ul class="logistics-list">
                  <li class="logistics-item">物流公司：{{expressInfo.express}}</li>
                  <li class="logistics-item">运单号：{{expressInfo.waybillCode}}</li>
                </ul>
                <ul class="logistics-list">
                  <li class="logistics-item">联系人：{{receiptInfo.receiver}}</li>
                  <li class="logistics-item">联系电话：{{receiptInfo.telephone}}</li>
                </ul>
                <ul class="logistics-list">
                  <li class="logistics-item border0">收货地址：{{receiptInfo.fullAddress}}</li>
                </ul>
                <ul class="logistics-list">
                  <li class="logistics-item border0">发货地址：{{receiptInfo.deliveryAddress}}</li>
                </ul>
              </div>
            </div>
            <div class="print-repair" v-show="isShowRepairInfo">
              <p class="printer-title">返修单</p>
              <div class="printer-message">
                <ul class="list">
                  <li class="list-item">客户姓名：{{customInfo.name}}</li>
                  <li class="list-item">收货地址：</li>
                </ul>
                <ul class="list list-right">
                  <li class="list-item">收货人：</li>
                  <li class="list-item">联系方式：</li>
                </ul>
              </div>
              <div class="table">
                <el-table class="table-printer" :data="selectTableData" style="width:100%">
                  <el-table-column label="商品名称">
                    <template slot-scope="props">
                      <p>{{props.row.goodsName}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" prop="quantity"></el-table-column>
                  <el-table-column label="备注" prop="message"></el-table-column>
                </el-table>
              </div>
              <div class="printer-option-message">
                <p>打印时间：{{nowDate}}</p>
                <p>操作员：{{userRealName}}</p>
              </div>
            </div>
          </div>
          <div class="footer">
            <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
            <el-button class="btn-blue" v-print="'#printer'" @click="print">确定</el-button>
          </div>
        </el-dialog>

        <!-- 修改收货地址 -->
        <el-dialog class="to-ship-container receiptInfo" :visible.sync="showModHarvestAddress" width="420px">
          <span class="title" slot="title">修改收货地址</span>
          <div class="content">
            <el-form :model="receiptInfo" :rules="receiptInfoRules" ref="receiptInfo" label-width="100px" class="demo-ruleForm">
              <el-form-item label="收货人：" prop="receiver">
                <el-input class="gray" v-model="receiptInfo.receiver"></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="telephone">
                <el-input class="gray" v-model="receiptInfo.telephone"></el-input>
              </el-form-item>
              <el-form-item label="地区：" prop="proCityDisIdArr">
                <el-cascader
                  v-model="receiptInfo.proCityDisIdArr"
                  :options="addressList"
                  :props="cascaderProps"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="详细地址：" prop="address">
                <el-input class="gray" v-model="receiptInfo.address"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="btns">
            <el-button class="btn-white" @click="cancelModHarvestAddress">取消</el-button>
            <el-button class="btn-blue" @click="saveHarvestAddress('receiptInfo')">保存</el-button>
          </div>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import IntInput from "components/base/IntInput";
import DecimalInput from "components/base/DecimalInput";
import {
  getDBUserRealName,
  getDBModuleStatusPermission,
} from "common/js/storage";
import { orderStatusToDesc, formaTimeToSecond, formatTimeToDate, isImage, isImgSizeLt2M } from "common/js/util.js";
import DBOrder from "models/db/order.js";
import DBAddress from "models/db/address.js";
import ImgUploader from "models/img-upload.js";
const imgUploader = new ImgUploader();
const dbOrder = new DBOrder();
const dbAddress = new DBAddress();
const defaultGoodPic = "http://image.8844it.com/ydb2/goodDefault.png";
const pageModules = {
  viewModule: 1,
  editModule: 2,
};
const infoTypes = {
  orderInfo: 1,
  shipmentInfo: 2,
  repairInfo: 3,
  paymentRecords: 4,
  operationLog: 5,
};
const payMethodMap = {
  0: "无",
  1: "线下银行卡转账",
  2: "线上支付宝",
  3: "诚店宝支付",
  4: "农行支付",
  5: "线上微信",
  6: "线下支付宝转账",
  7: "线下微信转账",
  8: "线下其他转账",
};
const orderStatusMap = {
  waitPay: 0,
  waitCheckOrder: 1,
  passCheckOrder: 2,
  rejectCheckOrder: 3,
  waitCheckFinance: 4,
  waitCheckOutStore: 5,
  waitShip: 7,
  waitReceive: 8,
  hasCompleted: 9,
  hasCanceled: 10,
};
// 待付款状态
const WAIT_PAY = 0;
// 待订单审核状态
const WAIT_CHECK_ORDER = 1;
// 待出库审核状态
const WAIT_CHECK_OUT = 5;
// 待发货状态
const WAIT_SHIP = 7;
export default {
  data() {
    return {
      orderId: null,
      isMeal: false, //是否为套餐
      setMealId: 0, //套餐id
      showShipDialog: false,
      selectedLogis: "",
      waybillCode: "",
      logisList: [],
      // 以上为发货信息相关
      showModHarvestAddress: false,
      infoTypes,
      orderCode: 0,
      pageModule: pageModules.viewModule,
      infoType: infoTypes.orderInfo,
      currOrderStatus: "",
      currOrderDesc: "",
      customInfo: {
        name: "",
        area: "",
        contact: "",
        telephone: "",
        payMethod: "",
        payMethodDesc: "",
        payStatus: "",
        message: "",
      },
      orderDetail: [],
      paymentInfo: {
        orderTotal: 0, // 商品合计
        temporaryTotal: 0, //临时商品合计
        freight: 0, // 运费
        promotionPrice: 0, // 促销减价
        couponPrice: 0, // 优惠劵
        discount: 0, // 商家优惠
        needToPay: 0, // 实际支付
        message: "",
        setMeal: 0,
        integralValue: 0,
      },
      orderInfo: {
        orderNum: "",
        paymentNum: "",
        createOrderTime: "",
        completePayTime: "",
        completeOrderTime: "",
        dbMessage: "",
      },
      expressInfo: {
        waybillCode: "",
        express: "",
      },
      outStoreRecordList: [],
      // 物流--收货信息
      receiptInfo: {
        receiver: "",
        telephone: "",
        fullAddress: "",
        address: "",
        // 已选择的地址 [省id, 市id, 区id]
        proCityDisIdArr: [],
        deliveryAddress: "",
      },
      receiptInfoRules: {
        receiver: [
          { required: true, message: '请输入收货人', trigger: 'blur' },
        ],
        telephone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        proCityDisIdArr: [
          { required: true, message: '请选择地区', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ]
      },
      showLogisInfo: false,
      addressList: [],
      cascaderProps: {
        value: "id",
        label: "name",
      },
      // 凭证相关
      showVoucher: false,
      voucherList: [],
      // 当前展示的是第几张凭证
      currVoucherIndex: 0,
      domain: "",
      LogisDetail: "", // 物流信息
      dialogVisible: false, // 物流弹窗
      moduleStorage: "", // 仓库是否开启
      printerDialog: false, //打印弹窗
      nowDate: "",
      userRealName: "",
      updateCommodityIndex: "",
      //临时商品数据
      moduleTempGoods: false,
      // 积分模块
      modulePoints: false,
      temporaryData: [],
      updateTemporaryIndex: "",
      delTemporaryIds: [],
      repairList: [],
      selectTableData: [],
      paymentRecordsList: [], 
      paymentList: [],  //付款方式列表
      // 上传图片文件
      selectedImgFile: null,
      // 已上传的凭证图片列表
      voucherImgList: [],
      tradeSerialNo: '',
      payAmount	: '',
      payDate	: '',
      desc:'',
      paymentRadio: '',
      paymentPrice: '',
      outstanding: '',  //尚未支付金额
      paymentAccount: false, //控制选择打款账号
      accountInfo: {}, //账号信息
      // 所有支付方式
      payMethodList: [
        {
          status: 0,
          value: "无",
        },
        {
          status: 1,
          value: "线下银行卡转账",
        },
        {
          status: 2,
          value: "线上支付宝",
        },
        {
          status: 3,
          value: "诚店宝支付",
        },
        {
          status: 4,
          value: "农行支付",
        },
        {
          status: 5,
          value: "线上微信",
        },
        {
          status: 6,
          value: "线下支付宝转账",
        },
        {
          status: 7,
          value: "线下微信转账",
        },
        {
          status: 8,
          value: "线下其它转账",
        },
      ],
      paymentAddFlag: true,
      /* ------------------------- 以下是操作日志 ------------------------ */
      operationLogList: [],
      operationLogTypeObj: {
        ORDER_SUBMISSION: "订单提交",
        ORDER_REVIEW: "订单审核",
        FINANCIAL_REVIEW: "财务审核",
        OUTBOUND_REVIEW: "出库审核",
        DELIVERY_CONFIRMATION: "发货确认",
        RECEIPT_CONFIRMATION: "收货确认",
        ORDER_PAYMENT: "订单付款",
        ORDER_VOIDED: "订单作废",
        ORDER_CANCEL: "订单取消",
        REFUND_CONFIRMATION: "退款确认"
      }
    };
  },
  computed: {
    tip() {
      return `${this.currVoucherIndex + 1}/${this.voucherList.length}页`;
    },
    maxVouncherIndex() {
      return this.voucherList.length - 1;
    },
    isViewModule() {
      return this.pageModule === pageModules.viewModule;
    },
    isEditModule() {
      return this.pageModule === pageModules.editModule;
    },
    isShowOrderInfo() {
      return this.infoType === infoTypes.orderInfo;
    },
    isShowExpress() {
      return !!this.expressInfo.express;
    },
    isShowShipmentInfo() {
      return this.infoType === infoTypes.shipmentInfo;
    },
    isShowRepairInfo() {
      return this.infoType === infoTypes.repairInfo;
    },
    isShowPaymentRecords() {
      return this.infoType === infoTypes.paymentRecords;
    },
    isShowOperationLog() {
      return this.infoType === infoTypes.operationLog;
    },
    isShowViewFooterOperation() {
      return (
        (this.currOrderStatus === WAIT_PAY &&
          this.pageModule === pageModules.viewModule) ||
        (this.currOrderStatus === WAIT_CHECK_ORDER &&
          this.pageModule === pageModules.viewModule &&
          this.customInfo.payStatus === 0)
      );
    },
    isShowEditFooterOperation() {
      return (
        this.currOrderStatus === WAIT_PAY &&
        this.pageModule === pageModules.editModule
      );
    },
    isShowOutOfStoreBtn() {
      return this.currOrderStatus === WAIT_CHECK_OUT;
    },
    isShowShipBtn() {
      return this.currOrderStatus === WAIT_SHIP;
    },
    outStoreRecordIsEmpty() {
      return this.expressInfo.waybillCode || this.outStoreRecordList.length > 0;
    },
    //临时商品合计
    temporaryTotal() {
      let total = 0;
      this.temporaryData.map((item) => {
        total += Number(item.unitPrice) * Number(item.quantity);
      });
      this.paymentInfo.temporaryTotal = total;
      return total;
    },
  },
  watch: {
    showShipDialog: {
      handler(newVal) {
        if (!newVal) {
          this.selectedLogis = "";
          this.waybillCode = "";
        }
      },
    },
    orderDetail: {
      deep: true,
      handler(newValue) {
        if (!this.isMeal) {
          let total = 0;
          newValue.map((item) => {
            item.subtotal = ((item.unitPrice * item.amount * 100) / 100).toFixed(2);
            total += (item.subtotal * 100) / 100;
          });
          this.paymentInfo.orderTotal = total;
        }
      },
    },
    paymentInfo: {
      deep: true,
      handler(newValue) {
        let newNeedToPayAmount =
          (
            newValue.orderTotal * 100 +
              this.temporaryTotal * 100 +
              newValue.freight * 100 -
              newValue.discount * 100 -
              newValue.promotionPrice * 100 -
              newValue.setMeal * 100 -
              newValue.integralValue * 100 -
              newValue.couponPrice * 100
          ) / 100;
        if (newNeedToPayAmount <= 0) {
          this.paymentInfo.discount = 0;
          return false;
        }
        this.paymentInfo.needToPay =
          newNeedToPayAmount > 0 ? newNeedToPayAmount : 0;
      },
    },
    printerDialog: {
      handler(newVal) {
        if (newVal) {
          let date = new Date();
          this.nowDate = formaTimeToSecond(date.getTime());
          this.userRealName = getDBUserRealName()
            ? getDBUserRealName()
            : "暂无";
        }
      },
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.selectTableData = []
      val.map((val) => {
        this.selectTableData.push(val);
      });
    },
    viewVoucher() {
      this.showVoucher = true;
    },
    closeVoucher() {
      this.showVoucher = false;
    },
    // 切换到前一张凭证
    prevVoucher() {
      if (this.currVoucherIndex === 0) {
        // 如果当前凭证是第一张
        this.currVoucherIndex = this.maxVouncherIndex;
      } else {
        this.currVoucherIndex--;
      }
      this.$refs.carouselList.style.transform = `translate3d(-${
        this.currVoucherIndex * 770
      }px, 0, 0)`;
    },
    // 切换到后一张凭证
    nextVoucher() {
      if (this.currVoucherIndex === this.maxVouncherIndex) {
        // 如果当前凭证是最后一张
        this.currVoucherIndex = 0;
      } else {
        this.currVoucherIndex++;
      }
      this.$refs.carouselList.style.transform = `translate3d(-${
        this.currVoucherIndex * 770
      }px, 0, 0)`;
    },
    onShip() {
      this.showShipDialog = true;
    },
    cancelShip() {
      this.showShipDialog = false;
    },
    toShip() {
      this.debounceConfirmToShipFnc()
    },
    
    _confirmToShip() {
      let data = {
        orderCode: this.orderCode,
        expressId: this.selectedLogis,
        expressCode: this.waybillCode,
      };
      this._confirmShip(data);
    },
    /* 防抖 */
    debounce(fn, delay) {
      let timer = null
      return function () {
        if (timer) {
          clearTimeout(timer)
          console.log('拦截')
        }
        timer = setTimeout(() => {
          console.log('发送')
          fn.apply(this, arguments)
          timer = null
        }, delay)
      }
    },
    reviewOutOfStore() {
      this.$confirm(`是否出库`, "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 出库
        let outStockGoodsList = [];
        this.orderDetail.map((good) => {
          if (!good.isTemp) {
            outStockGoodsList.push({
              id: good.id,
              warehouseId: good.selectedStoreId,
            });
          }
        });
        let data = {
          orderCode: this.orderCode,
          outStockGoodsList,
        };
        this._reviewOutOfStore(data);
      });
    },
    onUpdateAmount(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterAmountNum(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.orderDetail[this.updateCommodityIndex])
      );
      commodity.amount = val;
      this.orderDetail.splice(this.updateCommodityIndex, 1, commodity);
    },
    onUpdateUnitPrice(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterUnitPrice(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.orderDetail[this.updateCommodityIndex])
      );
      commodity.unitPrice = val;

      this.orderDetail.splice(this.updateCommodityIndex, 1, commodity);
    },
    filterOrderTotal(val) {
      this.paymentInfo.orderTotal = val;
    },
    filterFreightNum(val) {
      this.paymentInfo.freight = val;
    },
    filterDiscountNum(val) {
      this.paymentInfo.discount = val;
    },
    filterCouponPriceNum(val) {
      this.paymentInfo.couponPrice = val;
    },
    filterPromotionPriceNum(val) {
      this.paymentInfo.promotionPrice = val;
    },
    toOrderList() {
      this.$router.push({
        path: "/admin/order/order-form/order-list",
      });
      window.location.reload();
    },
    //添加临时商品
    addTemporary() {
      let obj = {
        goodsName: "",
        itemTitle: "",
        quantity: 1,
        unitPrice: "",
      };
      this.temporaryData.push(obj);
    },
    //删除临时商品
    delTemporary(index) {
      this.temporaryData.splice(index, 1);
    },
    //删除表格里的临时商品
    delTableTemporary(index, id) {
      this.orderDetail.splice(index, 1);
      this.delTemporaryIds.push(id);
    },
    //修改临时商品数量
    onUpdateTemporary(updateIndex) {
      this.updateTemporaryIndex = updateIndex;
    },
    filterTemporary(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.temporaryData[this.updateTemporaryIndex])
      );
      commodity.quantity = val;
      this.temporaryData.splice(this.updateTemporaryIndex, 1, commodity);
    },
    //修改临时商品价格
    filterTemporaryUnitPrice(event, index) {
      let commodity = JSON.parse(JSON.stringify(this.temporaryData[index]));
      commodity.unitPrice = event;
      this.temporaryData.splice(index, 1, commodity);
    },
    // 切换为编辑模式
    toUpdateOrder() {
      this._switchEditModule();
    },
    // 保存编辑
    updateOrder() {
      let orderDetail = [];
      let tempOrderDetailList = [];
      this.orderDetail.map((item) => {
        if (!item.isTemp) {
          orderDetail.push({
            id: item.id,
            unitPrice: item.unitPrice,
            quantity: item.amount,
          });
        } else {
          tempOrderDetailList.push({
            goodsName: item.commodityName,
            itemTitle: item.norm,
            unitPrice: item.unitPrice,
            quantity: item.amount,
          });
        }
      });
      //验证临时商品
      let temporaryStop = false;
      this.temporaryData.map((value) => {
        if (value.goodsName === "") {
          temporaryStop = true;
        } else if (value.itemTitle === "") {
          temporaryStop = true;
        } else if (value.unitPrice === "" || Number(value.unitPrice) === 0) {
          temporaryStop = true;
        }
      });
      if (temporaryStop) {
        this.$alert("请填入完整临时商品信息", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      tempOrderDetailList = tempOrderDetailList.concat(this.temporaryData);
      let order = {
        setMealId: this.setMealId,
        goodsTotalPrice: this.paymentInfo.orderTotal,
        orderCode: this.orderCode,
        freight: String(this.paymentInfo.freight),
        discount: String(this.paymentInfo.discount),
        couponDiscount: String(this.paymentInfo.couponPrice),
        promotionReduce: String(this.paymentInfo.promotionPrice),
        dbMessage: this.orderInfo.dbMessage,
      };
      let address = {
        receivedName: this.receiptInfo.receiver,
        receivedPhone: this.receiptInfo.telephone,
        province: this.receiptInfo.proCityDisIdArr[0],
        city: this.receiptInfo.proCityDisIdArr[1],
        regions: this.receiptInfo.proCityDisIdArr[2],
        address: this.receiptInfo.address,
      };
      let data = {
        orderDetail,
        order,
        address,
        tempOrderDetailList,
      };
      this._updateOrder(data);
    },
    cancelUpdate() {
      this._switchViewModule();
      // 重新获取详情--因为编辑过程可能修改了值
      let orderCode = this.$route.query.orderCode;
      this._getDBOrderDetailByCode(orderCode);
      this._switchViewModule();
      this.temporaryData = [];
    },
    _reviewOutOfStore(data) {
      dbOrder.reviewOutOfStore(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "审核通过",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
          this.initOperationLog()
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 更新订单
    _updateOrder(data) {
      dbOrder.updateOrder(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this.temporaryData = [];
          this._getDBOrderDetailByCode(this.orderCode);
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
        // 切换为浏览模式
        this._switchViewModule();
      });
    },
    _getDBOrderDetailByCode(orderCode) {
      dbOrder.getDBOrderDetailByCode(orderCode).then((res) => {
        if (res.success) {
          let {
            repairList,
            deliveryAddress,
            orderAddress,
            xbInfo,
            detailList,
            moduleStorage,
            expressRecord,
            payment,
            storageOutRecord,
            order,
            tempDetailList,
          } = res.result;
          let repairArr = []
          repairList.map(v => {
            let obj = {}
            obj.createTime = formatTimeToDate(v.createTime)
            obj.goodsName = v.goodsName
            obj.quantity = v.quantity
            obj.message = v.message
            obj.id = v.id
            repairArr.push(obj)
          })
          this.repairList = repairArr
          this.setMealId = order.setMealId ? order.setMealId : 0;
          this.isMeal = order.setMealId ? true : false;
          // 当前仓库状态是否开启
          this.moduleStorage = moduleStorage;
          // 当前订单状态描述
          this.currOrderStatus = order.status;
          this.currOrderDesc = orderStatusToDesc(order.status);
          // 凭证列表
          this.voucherList = [];
          if (order.enclosure) {
            order.enclosure.map((item) => {
              this.voucherList.push(item);
            });
          }
          // 客户相关信息
          if (xbInfo) {
            this.customInfo.name = xbInfo.name;
            if (xbInfo.regionsValue) {
              this.customInfo.area = xbInfo.cityValue + xbInfo.regionsValue;
            } else {
              this.customInfo.area = xbInfo.cityValue;
            }
            this.customInfo.contact = xbInfo.contact;
            this.customInfo.telephone = xbInfo.telephone;
          }
          this.customInfo.payMethod = payment.paymentMethod;
          this.customInfo.payMethodDesc = payMethodMap[payment.paymentMethod];
          this.customInfo.payStatus = payment.paymentStatus;
          this.paymentInfo.message = payment.message;
          this.customInfo.message = order.xbMessage ? order.xbMessage : "无";
          // 订单详情--商品列表
          this.orderDetail = [];
          detailList.map((item) => {
            let normList = JSON.parse(item.itemTitle);
            let norm = "";
            for (let key in normList) {
              norm += `,${normList[key]}`;
            }
            let storeList = [];
            // item.wareHouseAndNum.map((store) => {
            //   storeList.push({
            //     desc: `${store.name}(库存：${store.num})`,
            //     id: store.id,
            //   });
            // });
            let wareHouseName = ''
            item.wareHouseAndNum.map(v => {
              wareHouseName += `/${v.warehouseName}(${v.quantity})`
            })
            this.orderDetail.push({
              isTemp: false,
              id: item.id,
              setMealId: item.setMealId,
              code: item.goodsCode,
              commodityImg: item.goodsPic ? item.goodsPic : defaultGoodPic,
              commodityName: item.goodsName,
              wareHouseName: wareHouseName.substring(1),
              norm: norm.substring(1),
              unitPriceShow: (item.unitPrice - (item.promotionReduce/item.quantity)).toFixed(2),
              unitPrice: item.unitPrice,
              // 商品数量--即订购数
              amount: item.quantity,
              subtotal: item.subtotal,
              promotionReduce: item.promotionReduce,
              // 出货仓库列表
              storeList: storeList,
              // 选择的仓库
              selectedStoreId: storeList.length > 0 ? storeList[0].id : "",
              // 订购数
              numOfOrder: item.quantity,
              // 已出库数
              numOfOut: item.storageOutSum,
              // 本次出库数
              currNumOfOut: item.quantity,
            });
          });
          tempDetailList.map((item) => {
            this.orderDetail.push({
              isTemp: true,
              id: item.id,
              code: item.goodsCode,
              commodityImg: item.goodsPic ? item.goodsPic : defaultGoodPic,
              commodityName: item.goodsName,
              norm: item.itemTitle,
              unitPriceShow: (item.unitPrice - (item.promotionReduce/item.quantity)).toFixed(2),
              unitPrice: item.unitPrice,
              // 商品数量--即订购数
              amount: item.quantity,
              subtotal: item.subtotal,
              promotionReduce: item.promotionReduce,
              // 订购数
              numOfOrder: item.quantity,
            });
          });
          // 订单详情--合计
          this.paymentInfo.orderTotal = order.totalPrice;
          this.paymentInfo.freight = order.freight;
          this.paymentInfo.promotionPrice = order.promotionReduce;
          this.paymentInfo.integralValue = order.pointsDeductedAmount;
          this.paymentInfo.discount = payment.discount;
          this.paymentInfo.couponPrice = payment.couponDiscount;
          this.paymentInfo.needToPay = order.paymentPrice;
          if (payment.paymentStatus == 1) {
            this.outstanding = 0;
          } else {
            this.outstanding = order.paymentPrice;
          }
          this.paymentPrice = order.paymentPrice;
          this.payAmount = this.paymentPrice
          this.paymentInfo.setMeal = payment.setMealReduce
          // if (order.setMealId != 0) {
          //   let setMeal = 0
          //   this.orderDetail.map(i => {
          //     setMeal += i.subtotal
          //   })
          //   this.paymentInfo.setMeal = (setMeal-this.paymentInfo.orderTotal-this.temporaryTotal).toFixed(2);
          // } else {
          //   this.setMeal = 0
          // }
          // 订单详情--编号+时间+商家备注
          this.orderInfo.orderNum = order.orderCode;
          this.orderInfo.paymentNum = order.paymentCode
            ? order.paymentCode
            : null;
          this.orderInfo.createOrderTime = formaTimeToSecond(order.createTime);
          this.orderInfo.completePayTime = order.paymentTime
            ? formaTimeToSecond(order.paymentTime)
            : null;
          this.orderInfo.completeOrderTime = order.finishedTime
            ? formaTimeToSecond(order.finishedTime)
            : null;
          this.orderInfo.dbMessage = order.dbMessage;
          // 操作记录相关信息
          this.outStoreRecordList = [];
          if (storageOutRecord.length) {
            storageOutRecord.map((record) => {
              this.outStoreRecordList.push({
                // 出库单号
                outStoreCode: record.outStockCode,
                // 出库时间
                outStoreTime: formaTimeToSecond(record.outStockTime),
                // 出库仓库
                outStoreName: record.warehouseName,
              });
            });
          }
          if (expressRecord) {
            this.expressInfo.waybillCode = expressRecord.expressCode
              ? expressRecord.expressCode
              : "无";
            this.expressInfo.express = expressRecord.expressName
              ? expressRecord.expressName
              : "无";
          }
          // 编辑修改收货地址
          let {
            receivedName,
            receivedPhone,
            address,
            fullAddress,
            province = "",
            city = "",
            regions = "",
          } = orderAddress;
          this.receiptInfo.receiver = receivedName;
          this.receiptInfo.telephone = receivedPhone;
          this.receiptInfo.address = address;
          this.receiptInfo.fullAddress = fullAddress;
          this.receiptInfo.deliveryAddress = deliveryAddress;
          if (!regions) {
            this.receiptInfo.proCityDisIdArr = [province, city];
          } else {
            this.receiptInfo.proCityDisIdArr = [province, city, regions];
          }
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        this.addressList = res;
      });
    },
    // 切换为浏览模式
    _switchViewModule() {
      this.pageModule = pageModules.viewModule;
    },
    // 切换为编辑模式
    _switchEditModule() {
      this.pageModule = pageModules.editModule;
    },
    // 发货确认
    _confirmShip(data) {
      dbOrder.confirmShip(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "发货成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
          this.initOperationLog()
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
        this.showShipDialog = false;
      });
    },
    // 获取所有快递公司列表
    _getLogisList() {
      dbOrder.getLogisList().then((res) => {
        if (res.success) {
          this.logisList = [];
          res.result.map((item) => {
            this.logisList.push({
              id: item.id,
              expressName: item.expressName,
              expressApi: item.expressApi,
            });
          });
        }
      });
    },
    // 获取当前物流信息
    getLogisDetail(orderCode) {
      dbOrder.getDBLogisDetailByCode(orderCode).then((res) => {
        if (res.success) {
          if (res.result) {
            let arr = [];
            res.result.Traces.map((value) => {
              let obj = {};
              obj.remark = value.AcceptStation;
              obj.datetime = value.AcceptTime;
              arr.unshift(obj);
            });
            this.LogisDetail = arr;
          } else {
            this.LogisDetail = [];
          }
        }
      });
    },
    openPrinterDialog() {
      if (this.isShowRepairInfo) {
        if (this.repairList.length>0&&this.selectTableData.length == 0) {
          this.$message({
            message: '请先勾选返修数据',
            center: true,
            type: "error",
            duration: 1000,
          });
          return
        }
      }
      this.printerDialog = true;
    },
    closePrinterDialog() {
      this.printerDialog = false;
    },
    repairPrint() {
      let ids = []
      this.selectTableData.map(i => {
        ids.push(i.id)
      })
      let data = {
        ids: ids,
        orderCode: this.orderCode
      }
      dbOrder.repairPrint(data).then(res => {
        if (res.success) {
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      })
    },
    print() {
      this.repairPrint()
    },
    // 审核
    onCheck() {
      let data = {
        orderCode: this.orderInfo.orderNum,
      };
      switch (this.currOrderStatus) {
        // 订单审核
        case orderStatusMap.waitCheckOrder:
          this.$confirm(
            `是否确认订单${this.orderInfo.orderNum}通过订单审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "拒绝",
              distinguishCancelAndClose: true,
              type: "warning",
            }
          )
            .then((action) => {
              // 订单审核通过
              data.flag = 1;
              this._checkOrder(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 订单审核不通过
                data.flag = 0;
                this._checkOrder(data);
              }
            });
          break;
        case orderStatusMap.waitCheckFinance:
          // 财务审核
          this.$confirm(
            `是否确认订单${this.orderInfo.orderNum}通过财务审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              // 财务审核通过
              this._checkFinance(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 什么也不做
                return "";
              }
            });
          break;
        case orderStatusMap.waitCheckOutStore:
          this.$confirm(
            `是否确认订单${this.orderInfo.orderNum}通过出库审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              // 出库审核
              this._checkOutStore(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 什么也不做
                return "";
              }
            });
          break;
        default:
          break;
      }
    },
    // 订单审核
    _checkOrder(data) {
      dbOrder.checkOrder(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
          this.initOperationLog()
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 财务审核
    _checkFinance(data) {
      dbOrder.checkFinance(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
          this.initOperationLog()
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 出库审核
    _checkOutStore(data) {
      dbOrder.checkOutStore(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
          this.initOperationLog()
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 附件上传
    imgFileChange(file) {
      // 每次进来前清空
      this.selectedImgFile = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      if (this.voucherImgList.length > 1) {
        this.$alert("最多上传1张凭证", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      this.selectedImgFile = file.raw;
    },
    beforeUploadImg() {
      return !!this.selectedImgFile;
    },
    removeVoucherImg(index) {
      this.voucherImgList.splice(index, 1);
    },
    // 自定义上传
    uploadImg() {
      if (this.selectedImgFile) {
        imgUploader
          .postImgUpload(this.selectedImgFile)
          .then((res) => {
            if (!res.errorCode) {
              this.voucherImgList.push(res.imgUrl);
            } else {
              this.$message({
                message: "图片上传失败，请重试",
                center: true,
                type: "error",
                duration: 1000,
              });
            }
          })
          .catch((e) => {
            console.log("图片上传失败", e);
          });
      }
    },
    toogleExpand(row) {
      row.paymentDetailsFlag = false
      let $table = this.$refs.table;
      // this.paymentRecordsList.map((item) => {
      //   if (row.id != item.id) {
      //     $table.toggleRowExpansion(item, false)
      //     item.paymentDetailsFlag = true
      //   }
      // })
      $table.toggleRowExpansion(row,true)
    },
    putExpand(row) {
      row.paymentDetailsFlag = true
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row,false)
    },
    //再来一单
    encore() {
      this.$router.push({
        path: "/admin/order/order-form/add-order",
        query: {
          encore: true,
          orderCode: this.orderCode,
          area: this.receiptInfo.proCityDisIdArr,
          address: this.receiptInfo.address,
          receiveName: this.receiptInfo.receiver,
          phoneNumber: this.receiptInfo.telephone
        }
      });
    },
    //添加打款记录
    addPaymentRecords() {
      this.paymentAccount = true
      this.getBank()
    },
    //付款记录保存
    paymentSave() {
      if (this.paymentRadio == '') {
        this.$message({
          message: '请选择打款账号',
          center: true,
          type: "error",
          duration: 1000,
        });
        return
      }
      if (this.tradeSerialNo == '') {
        this.$message({
          message: '请输入汇款流水号',
          center: true,
          type: "error",
          duration: 1000,
        });
        return
      }
      if (!this.tradeSerialNo.replace(/[^\w\.\/]/ig,'')) {
        this.$message({
          message: '汇款流水号请输入字母和数字',
          center: true,
          type: "error",
          duration: 1000,
        });
        return
      }
      if (this.payDate == '') {
        this.$message({
          message: '请选择日期',
          center: true,
          type: "error",
          duration: 1000,
        });
        return
      }
      let payType = 0
      let payInfo = ''
      if (this.accountInfo.type == 1) {
        payType = 1
        payInfo = `${this.accountInfo.accountName}  ${this.accountInfo.bankName}  ${this.accountInfo.accountCode}`
      } else if (this.accountInfo.type == 2) {
        payType = 6
        payInfo = ''
      } else if (this.accountInfo.type == 3) {
        payType = 7
        payInfo = ''
      } else if (this.accountInfo.type == 4) {
        payType = 8
        payInfo = ''
      }
      let data = {
        orderCode: this.orderCode,
        payType: payType,
        totalAmount: this.payAmount,
        payDate: this.payDate,
        payAmount: this.payAmount,
        tradeSerialNo: this.tradeSerialNo,
        desc: this.desc,
        payInfo: payInfo,
        certificate: this.voucherImgList[0]?this.voucherImgList:[],
      }
      dbOrder.setPaymentRecords(data).then(res => {
        if (res.success) {
          this.outstanding = 0
          this.paymentAccount = false
          this.paymentAddFlag = false
          this.getPaymentRecordsList()
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      })
    },
    changeRadio(row) {
      this.accountInfo = row
    },
    //付款列表
    getPaymentRecordsList() {
      dbOrder.getPaymentRecordsList(this.orderCode).then(res => {
        if (res.success) {
          res.result.map(i => {
            let obj = {}
            obj.tradeSerialNo = i.tradeSerialNo
            obj.payDate = i.payDate
            obj.payAmount = i.payAmount
            obj.payType = i.payType
            this.payMethodList.map(val => {
              if (i.payType == val.status) {
                obj.payTypeValue = val.value
              }
            })
            obj.desc = i.desc
            obj.accountInfo = i.accountInfo
            obj.certificate = i.certificate
            obj.paymentDetailsFlag = true
            this.paymentRecordsList.push(obj)
          })
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      })
    },
    //获取账号信息
    getBank() {
      dbOrder
        .getBank()
        .then(res => {
          if (res.success) {
            res.result.map(i => {
              let obj = {}
              obj.accountName = i.accountName
              obj.bankName = i.bankName
              obj.accountCode = i.accountCode
              obj.id = i.id
              obj.type = i.type
              if (i.type === 2) {
                obj.accountName = '支付宝'
                obj.accountCode = ''
              }
              if (i.type === 3) {
                obj.accountName = '微信'
                obj.accountCode = ''
              }
              if (i.type === 4) {
                obj.accountName = '其他'
                obj.accountCode = ''
              }
              this.paymentList.push(obj)
              this.paymentRadio = this.paymentList[0].id
              this.accountInfo = this.paymentList[0]
            })
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
    },
    // 作废
    invalidate() {
      this.$confirm(`是否作废`, "作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let orderCode = this.orderInfo.orderNum
        let data = {
          orderCode
        }
        dbOrder.postVoidOrder(data).then(res => {
          if (res.success) {
            this._getDBOrderDetailByCode(this.orderCode);
            this.initOperationLog()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },
    
    /* --------------------------- 以下是操作日志方法 --------------------------------- */
    initOperationLog() {
      let orderCode = this.orderCode
      dbOrder.getOperationLogList(orderCode).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.operator = i.operateName
            obj.operatorTime = formaTimeToSecond(i.operateTime)
            obj.operatorType = this.operationLogTypeObj[i.operateType]
            obj.content = i.operateContent
            arr.push(obj)
          })
          this.operationLogList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 跳转出货/发货信息
    toShipmentInfo() {
      this.infoType = this.infoTypes.shipmentInfo
    },
    // 跳转付款记录
    toPaymentRecords() {
      this.infoType = this.infoTypes.paymentRecords
    },

    // 修改收货地址
    modHarvestAddress() {
      this.showModHarvestAddress = true
    },
    cancelModHarvestAddress() {
      this.showModHarvestAddress = false
    },
    saveHarvestAddress(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let receiveName = this.receiptInfo.receiver
          let phoneNumber = this.receiptInfo.telephone
          let province = this.receiptInfo.proCityDisIdArr[0]
          let city = this.receiptInfo.proCityDisIdArr[1]
          let region = this.receiptInfo.proCityDisIdArr[2]
          let address = this.receiptInfo.address
          let orderId = this.orderId
          let data = {
            receiveName,
            province,
            city,
            region,
            phoneNumber,
            address,
            orderId
          }
          dbOrder.modOrderAddress(data).then(res => {
            if (res.success) {
              this._getDBOrderDetailByCode(this.orderCode);
              this.cancelModHarvestAddress()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    this.orderCode = this.$route.query.orderCode;
    this.orderId = this.$route.query.orderId;
    let isTabs = this.$route.query.isTabs
    if (isTabs == 4) {
      this.infoType = this.infoTypes.paymentRecords
    } else {
      this.infoType = this.infoTypes.orderInfo
    }
    if (this.$route.query.showShip) {
      this.infoType = infoTypes.shipmentInfo;
    }
    this._getDBOrderDetailByCode(this.orderCode);
    // 获取城市数据列表
    this._getDBAddressMock();
    this.getLogisDetail(this.orderCode);
    // 获取物流列表
    this._getLogisList();
    // 当前域名
    this.domain = window.location.host;
    //是否可以添加临时商品
    this.moduleTempGoods = getDBModuleStatusPermission().moduleTempGoods === 1;
    this.modulePoints = getDBModuleStatusPermission().modulePoints === 1;
    //付款列表
    this.getPaymentRecordsList()
    // 操作日志
    this.initOperationLog()
    
    this.debounceConfirmToShipFnc = this.debounce(() => {
      this._confirmToShip()
    },1000)
  },
  mounted() {
    const paddingWidth = 68;
    this.$refs.operations.style.width =
      this.$refs.baseContent.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseContent.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    IntInput,
    DecimalInput,
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .setMeal-tags {
    width: 40px;
    height: 20px;
    line-height: 20px;
    margin-top: 2px;
    text-align: center;
    background: #DF3445;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    margin-right: 10px;
  }
  .preview-container {
    margin-top: 20px;
    display: flex;
    .img-container {
      width: 84px;
      height: 84px!important;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      position: relative;
      padding-left: 91px;
      .uploaded-img {
        width: 80px;
        height: 80px!important;
      }
      .cover {
        width: 84px;
        height: 84px!important;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0px;
        left: 91px;
        background: rgba(102, 102, 102, 0);
        z-index: 99;
        .delete-btn {
          width: 16px;
          height: 16px;
          background-image: url("../../../../assets/offline-pay/delete.png");
          background-size: 16px 16px;
          cursor: pointer;
          display: none;
        }
        &:hover {
          background: rgba(102, 102, 102, 0.5);
          .delete-btn {
            display: block;
          }
        }
      }
    }
  }
  .btn-black {
    background: #EEEEEE;
    color: #999999;
  }
  .radios-container {
    margin-top: 30px;
    position: relative;
    .invalidate {
      position: absolute;
      top: -22px;
      right: 0;
      border: 1px solid #409EFF;
      color: #409EFF;
      &:hover {
        background: #fff;
      }
    }
  }
  .order-information {
    padding: 20px 24px;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    color: rgba(96, 98, 102, 1);
    .customer-related {
      .top {
        display: flex;
        .left {
          width: 60%;
          .left-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 18px;
            .container {
              width: 50%;
              .desc {
                width: 76px;
                display: inline-block;
                text-align: right;
              }
            }
          }
        }
        .right {
          width: 40%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          .order-status {
            margin-left: 8px;
            color: royalblue;
          }
        }
      }
      .bottom {
        .desc {
          display: inline-block;
          width: 76px;
          text-align: right;
        }
      }
    }
    .order-detail-related {
      margin: 26px 0;
      .table-img {
        .table-container {
          .amount-input,
          .gray {
            width: 96px;
          }
          .scribing {
            text-decoration: line-through;
            margin-right: 10px;
          }
          .delete-btn {
            position: absolute;
            cursor: pointer;
            font-size: 12px;
            right: 10px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .subtotal {
        display: flex;
        padding: 12px 36px 12px 16px;
        border: 1px solid #eee;
        border-top: none;
        .detail {
          display: flex;
          align-items: center;
          flex: 1;
          .order-total,
          .order-freight,
          .order-discount,
          .order-couponPrice,
          .order-promotionPrice {
            margin-right: 30px;
          }
        }
        .amounts-payable {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .subtotal-edit {
        display: flex;
        padding: 12px 36px 12px 16px;
        border: 1px solid #eee;
        border-top: none;
        .detail {
          width: 50%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .desc {
            width: 85px;
            text-align: right;
          }
          .order-total {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .orderTotal-input {
              width: 85px;
            }
          }
          .order-freight {
            margin-left: 8px;
            margin-right: 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .freight-input {
              width: 80px;
            }
          }
          .order-discount {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .discount-input {
              width: 80px;
            }
          }
        }
        .amounts-payable {
          width: 50%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .gray {
            width: 96px;
          }
        }
      }
      .temporary-container {
        border-right: 1px solid #eee;
        border-left: 1px solid #eee;
        .temporary-item {
          height: 56px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #eee;
          .temporary-name {
            width: 400px;
            box-sizing: border-box;
            padding: 0 16px;
            .el-input {
              width: 100%;
            }
          }
          .temporary-spec {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .temporary-price {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .discount-input {
              width: 96px;
            }
          }
          .temporary-num {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .good-amount {
              width: 96px;
            }
          }
          .temporary-total {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
          }
          .el-input {
            width: 96px;
          }
          .delete-btn {
            position: absolute;
            cursor: pointer;
            font-size: 12px;
            right: 10px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .add-commodity-btn {
        width: 100%;
        height: 32px;
        line-height: 20px;
        padding: 6px 0 6px 16px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
        border: 1px solid #eee;
        border-top: none;
        .add-btn {
          cursor: pointer;
        }
      }
    }
    .pay-detail-related {
      padding-bottom: 20px;
      .container {
        margin-bottom: 18px;
        .desc {
          min-width: 100px;
          display: inline-block;
          text-align: right;
        }
      }
      .container-remark {
        display: flex;
        .textarea {
          width: 320px;
        }
      }
      .offline-payment-info {
        box-sizing: border-box;
        width: 100%;
        margin-top: 10px;
        font-size: 14px;
        line-height: 20px;
        padding-left: 16px;
        .container {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .btn-desc {
            display: inline-block;
            width: 80px;
            text-align: right;
          }
          .btn {
            color: rgba(61, 116, 242, 0.75);
            cursor: pointer;
            &:hover {
              color: rgba(61, 116, 242, 1);
            }
          }
        }
        .view-remark {
          margin-top: 18px;
          .remark {
            width: 80px;
            height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
  .shipment-info {
    display: flex;
    padding: 20px 24px;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    font-size: 14px;
    color: #666;
    .shipment-info-preview {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .order-info {
        height: 90px;
        background: rgba(251, 252, 253, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 0px 4px 4px 4px;
        font-size: 14px;
        color: #666666;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .code-status {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .code {
            margin-right: 120px;
            .desc {
              text-align: right;
              display: inline-block;
              width: 120px;
            }
          }
        }
        .receiver {
          .desc {
            text-align: right;
            display: inline-block;
            width: 120px;
          }
        }
      }
      .good-list {
        margin-top: 40px;
        .top {
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 16px;
            color: #666;
          }
        }
      }
      .operation-record {
        margin-top: 20px;
        .title {
          font-size: 16px;
          color: #666;
          margin-bottom: 16px;
        }
        .record-detail {
          min-height: 110px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding-left: 22px;
          border: 1px solid rgba(229, 229, 229, 1);
          border-radius: 0px 4px 4px 4px;
          font-size: 14px;
          color: #666;
          .record-info {
            margin-bottom: 10px;
            .row {
              line-height: 24px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
            .item {
              margin-right: 34px;
            }
          }
          .express-info {
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .item {
              margin-right: 34px;
            }
          }
        }
        .record-empty-tip {
          width: 100%;
          min-height: 110px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #e3e3e3;
        }
      }
    }
    .logistic-edit {
      padding: 20px 24px;
      border-radius: 0px 4px 4px 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      font-size: 14px;
      font-weight: 400;
      color: rgba(96, 98, 102, 1);
      .title {
        font-size: 16px;
        font-weight: 550;
        color: #606266;
        letter-spacing: 2px;
      }
      .container {
        display: flex;
        margin-top: 12px;
        margin-bottom: 26px;
        .desc {
          width: 80px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .gray {
          width: 250px;
        }
        .special {
          width: 480px;
        }
      }
    }
  }
  .repair-info {
    display: flex;
    padding: 20px 24px;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    font-size: 14px;
    color: #666;
    .table-img {
      width: 100%;
    }
  }
  .payment-records {
    .payment-head {
      background: #FBFCFD;
      border: 1px solid #EEEEEE;
      border-radius: 4px 4px 0px 0px;
      margin-bottom: 20px;
      .left {
        padding-top: 21px;
        padding-left: 21px;
      }
    }
    .payment-foot {
      margin-top: 30px;
      .payment-foot-title {
        margin-bottom: 13px;
        font-size: 16px;
        font-weight: 400;
        color: #606266;
        line-height: 16px;
      }
      .payment-foot-top-main {
        height: 40px;
        background: #FBFCFD;
        border: 1px solid #EEEEEE;
        display: flex;
        align-items: center;
        padding-left: 21px;
        div {
          margin-right: 50px;
        }
        div:nth-child(1) {
          margin-right: 0px;
        }
      }
      .payment-foot-bottom {
        width: 450px;
        margin-top: 16px;
        padding-bottom: 65px;
        div {
          height: 32px;
          display: flex;
          margin-bottom: 16px;
          span {
            width: 140px;
            text-align: right;
            line-height: 32px;
          }
        }
        .enclosure {
          span {
            width: 106px;
          }
          .tip {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 32px;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    z-index: 100;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    .btns {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .printer {
        width: 48px;
        padding: 0;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .btns-edit {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .to-ship-container {
    .title {
      font-size: 14px;
      color: #666666;
      font-weight: 550;
    }
    .content {
      box-sizing: border-box;
      border-top: 1px solid #ccc;
      padding-top: 24px;
      width: 100%;
      .container {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0px;
        }
        .label {
          width: 80px;
          text-align: right;
          margin-right: 6px;
        }
        .gray {
          width: 310px;
        }
      }
    }
    .btns {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 24px;
      }
    }
  }
  .cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(96, 98, 102, 0.5);
    z-index: 200;
    .close-btn-container {
      padding-top: 48px;
      padding-right: 48px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .close-btn {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 2px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        color: #fff;
        cursor: pointer;
      }
    }
    .carousel-container {
      box-sizing: border-box;
      width: 100vw;
      position: relative;
      display: flex;
      justify-content: center;
      .viewport {
        width: 770px;
        height: 500px;
        overflow: hidden;
        position: relative;
        .carousel-list {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: absolute;
          top: 0;
          .carousel-item {
            flex-shrink: 0;
            width: 770px;
            height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
            .voucher-img {
              max-height: 100%;
              max-width: 100%;
            }
          }
          .one {
            background: salmon;
          }
          .two {
            background: #df3445;
          }
          .three {
            background: #3d74f2;
          }
        }
      }
      .prev-btn {
        position: absolute;
        top: 250px;
        left: 20px;
        width: 16px;
        height: 16px;
        border-top: 4px solid #fff;
        border-right: 4px solid #fff;
        transform: rotate(225deg);
        cursor: pointer;
      }
      .next-btn {
        position: absolute;
        top: 250px;
        right: 40px;
        width: 16px;
        height: 16px;
        border-top: 4px solid #fff;
        border-right: 4px solid #fff;
        transform: rotate(45deg);
        cursor: pointer;
      }
    }
    .tip {
      width: 100vw;
      display: flex;
      justify-content: center;
      font-size: 16px;
      color: #fff;
    }
  }
  .required {
    img {
      width: 8px;
      height: 8px;
    }
  }
  .operator-btn {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    color: #606266;
  }
  .operation-log {
    margin-bottom: 80px;
  }
  .el-icon-edit {
    color: #409EFF;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
#orderDetail {
  .table-img {
    .el-table {
      .el-table__body-wrapper {
        .el-table__body {
          tbody {
            tr {
              td {
                .cell {
                  display: flex;
                  align-items: center;
                  .name {
                    color: #606266;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .to-ship-container {
    padding-left: 16px;
    padding-right: 16px;
    .el-dialog__header {
      padding: 12px 24px;
      line-height: 24px;
      font-size: 16px;
      color: #606266;
      .el-dialog__headerbtn {
        top: 13px;
      }
    }
    .el-dialog__body {
      padding: 0;
      .border {
        margin: 0 24px;
      }
      .logistics-info {
        height: 319px;
        padding: 0 24px;
        overflow: auto;
        .desces {
          padding: 8px 0px;
          display: flex;
          align-items: center;
          height: 24px;
          .desc-item {
            &:first-child {
              margin-right: 24px;
            }
            line-height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            white-space: nowrap;
          }
        }
        .list {
          padding-left: 14px;
          padding-bottom: 20px;
          li {
            border-left: 1px solid #f7f7f7;
            padding-left: 23px;
            position: relative;
            color: #919398;
            i {
              position: absolute;
              display: inline-block;
              left: -5px;
              width: 9px;
              height: 9px;
              border-radius: 50%;
              background: #c0c4cc;
            }
            .space {
              font-size: 12px;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .time {
              font-size: 12px;
              line-height: 17px;
              padding-bottom: 5px;
              border-bottom: 1px solid #f7f7f7;
            }
          }
        }
        .list li:nth-child(1) {
          i {
            position: absolute;
            display: inline-block;
            left: -8px;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #3d74f2;
          }
        }
      }
    }
  }
  .el-cascader {
    width: 252px;
    line-height: 32px;
    .el-input {
      line-height: 32px;
      .el-input__inner {
        height: 32px;
        background: rgba(234, 238, 245, 0.2);
        border: 1px solid #eaeef5;
      }
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
    }
  }
  .express-dialog {
    .el-dialog {
      height: 400px;
      font-family: "PingFangSC-Regular";
      .el-dialog__header {
        padding: 12px 24px;
        line-height: 24px;
        font-size: 16px;
        color: #606266;
        .el-dialog__headerbtn {
          top: 13px;
        }
      }
      .el-dialog__body {
        padding: 0;
        .border {
          margin: 0 24px;
        }
        .container {
          height: 319px;
          overflow: auto;
          padding: 0 24px;
          .express {
            padding: 8px 0px;
            display: flex;
            .express-p {
              line-height: 24px;
              height: 24px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(96, 98, 102, 1);
              line-height: 24px;
              letter-spacing: 1px;
              margin-right: 24px;
            }
          }
          .list {
            padding-left: 14px;
            padding-bottom: 20px;
            li {
              border-left: 1px solid #f7f7f7;
              padding-left: 23px;
              position: relative;
              color: #919398;
              i {
                position: absolute;
                display: inline-block;
                left: -5px;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: #c0c4cc;
              }
              .space {
                font-size: 12px;
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
              .time {
                font-size: 12px;
                line-height: 17px;
                padding-bottom: 5px;
                border-bottom: 1px solid #f7f7f7;
              }
            }
          }
          .list li:nth-child(1) {
            i {
              position: absolute;
              display: inline-block;
              left: -8px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #3d74f2;
            }
          }
        }
        .nothing {
          height: 319px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
  }
  .printer-dialog {
    .el-dialog__body {
      max-height: 80vh;
      overflow: auto;
      /* .printer {
        .printer-title {
          height: 64px;
          font-size: 32px;
          line-height: 64px;
          text-align: center;
        }
        .printer-message {
          display: flex;
          justify-content: space-between;
          .list {
            .list-item {
              font-size: 14px;
              padding-bottom: 16px;
            }
          }
          .list-right {
            width: 250px;
          }
        }
        .table {
          .price {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;
            border: 1px #f2f6fc solid;
            border-top: 0;
            .price-left {
              display: flex;
              p {
                margin: 0 16px;
              }
            }
            .price-right {
              display: flex;
              p {
                margin-right: 16px;
              }
            }
          }
          .remark {
            display: flex;
            height: 32px;
            border: 1px #f2f6fc solid;
            line-height: 32px;
            border-top: 0;
            .remark-title {
              width: 100px;
              border-right: 1px #f2f6fc solid;
              text-align: center;
            }
          }
        }
        .printer-option-message {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 32px;
        }
      } */
      .footer {
        height: 64px;
        box-sizing: border-box;
        padding-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .payment-foot-bottom {
    .textarea {
      height: 64px;
    }
    .el-textarea__inner {
      height: 64px!important;
      min-height: 64px!important;
      resize:none;
    }
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #606266;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
    padding-left: 27px;
    .el-form-item__label {
      text-align: right;
      margin-right: 30px;
    }
  }
  .table-enclosure {
    .el-icon-picture-outline {
      color: #dcdcdc;
      font-size: 64px;
    }
  }
  .receiptInfo {
    .el-dialog__header .el-dialog__headerbtn {
      top: 18px;
    }
    .el-dialog__body {
      padding: 0px;
      .content {
        padding: 20px;
        .el-cascader {
          width: 100%;
        }
      }
    }
    .el-dialog__footer {
      border-top: 1px solid #eee;
    }
  } 
}
</style>
<style midia="print">
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
}
#printer .printer-message {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
}
#printer .printer-message .list .list-right {
  width: 250px;
}
#printer .print-repair .list-right {
  margin-right: 160px;
}
#printer .table .price {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  border: 1px #000 solid;
  border-top: 0;
}
#printer .table .el-table {
  border: 1px solid #000;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .table .price .price-left {
  display: flex;
}
#printer .table .price .price-left p {
  margin: 0 16px;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
  padding: 0 0 0 10px;
}
#printer .table .el-table .el-table__header-wrapper .el-table__header tr th .cell {
  padding: 8px 10px;
}
#printer .table .price .price-right {
  display: flex;
}
#printer .table .price .price-right p {
  margin-right: 16px;
}
#printer .table th {
  width: 60px;
}
#printer .remark {
  display: flex;
  height: 32px;
  font-size: 12px;
  border: 1px #000 solid;
  line-height: 32px;
  border-top: 0;
}
#printer .remark .remark-title {
  width: 100px;
  border-right: 1px #000 solid;
  text-align: center;
}
#printer .remark .remark-content {
  padding-left: 10px;
}
#printer .printer-option-message {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  font-size: 12px;
}
#printer .printer-logistics {
  margin-top: 30px;
  border: 1px solid rgba(96, 98, 102, 1);
  border-bottom: 0;
  border-radius: 8px 8px 0px 0px;
}
#printer .printer-logistics .logistics-list {
  display: flex;
  min-height: 30px;
  border-bottom: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item:first-child {
  border-right: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item {
  flex: 1;
  min-height: 30px;
  line-height: 30px;
  padding-left: 16px;
}
#printer .printer-logistics .logistics-list .logistics-item.border0 {
  border-right: 0;
}
#printer .scribing {
  text-decoration: line-through;
  margin-right: 6px;
}
</style>

